import { useEffect, useRef, useState } from 'react';
import './AdminSidebar.scss';
import images from "../../assets/images/index";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { logout, setSplashvisible, setSystemMessagesCount } from '../../redux/slices/authSlice';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { SCHOOL_ADMIN } from '../../utils/constants';
import { Tooltip } from '@mui/material';
import { useLazyQuery } from '@apollo/client';
import { SYSTEM_MESSAGES_FROM_KATON, SYSTEM_MESSAGES_TOTAL_COUNT } from '../../pages/AdminSystemMessages/api/AdminSystemMessages';



const AdminSidebar = () => {
  const { DashboardIcon, HelpIcon, LogoutIcons, WorkshopIcon,
    SettingsIcons, logoutGif, NotificationIcon,SystemNotificationIcon, UploadIconDashboard
  } = images;
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { role, loginpage } = useAppSelector((state) => state.auth);
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const systemMessageCount = useAppSelector((state) => state?.auth?.systemMessagesCount)
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const schoolNameRef = useRef<HTMLDivElement | null>(null);
  // const [systemMessageCount, setSystemMessageCount] = useState<number>(0)
  const navigate = useNavigate();
  console.log("loginpage", loginpage);
  

  const schoolAdminMenus = [
    { id: 'Dashboard', label: "Dashboard", icon: DashboardIcon, link: "/admin-dashboard", set: "setOne" },
    { id: 'Upload', label: "Upload", icon: UploadIconDashboard, link: "/admin-materials-upload", set: "setOne" },
    { id: 'Workshop', label: "Workshop", icon: WorkshopIcon, link: "/admin-workshop", set: "setOne" },
    { id: 'Notification', label: "Notification", icon: NotificationIcon, link: "/admin-notification", set: "setOne" },
    { id: 'System-messages', label: "System Messages", icon: SystemNotificationIcon, link: "/admin-system-message", set: "setOne" },
    { id: 'Settings', label: "Settings", icon: SettingsIcons, link: "/admin-settings", set: "setTwo" },
    { id: 'Help', label: "Help", icon: HelpIcon, link: "/admin-help", set: "setTwo" },
  ];

  const facilitatorMenus = [
    { id: 'Workshop', label: "Workshop", icon: WorkshopIcon, link: "/facilitator-workshop", set: "setOne" }
  ];

  // Menu Item Set of Array
  const menuItems = [
    ...((role === SCHOOL_ADMIN && location.pathname !== "/facilitator-workshop") ? schoolAdminMenus : facilitatorMenus),
    { id: 'Logout', label: "Logout", icon: LogoutIcons, link: "/logout", set: "setThree" },
  ];

  // To Display only the expected Menu items in the Menu's in that Set
  const getMenuItemsBySet = (set: string) => menuItems.filter((item: any) => item.set === set);

  // click logout from sidebar
  const onLogoutClick = () => {
    setOpenConfirmationPopup(true);
  }

  // click yes button in confirmation popup
  const onYesButtonClick = () => {
    dispatch(logout());
    dispatch(setSplashvisible());
    setOpenConfirmationPopup(false);
  }

  // click no button in confirmation popup
  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  //To check the container is overflow
  const checkOverflow = () => {
    if (schoolNameRef.current) {
      setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
    }
  }

  //To check overflow in resize 
  useEffect(() => {
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [profile])

  const [system_messages_total_count] = useLazyQuery(SYSTEM_MESSAGES_TOTAL_COUNT, {
    fetchPolicy : 'network-only',
    onCompleted : (data) => {
      dispatch(setSystemMessagesCount(data.allSystemMessages.totalCount))
    }
  })

  const [system_messages_from_katon] = useLazyQuery(SYSTEM_MESSAGES_FROM_KATON,{
    fetchPolicy : 'network-only',
    onCompleted: (data) =>{
      system_messages_total_count()
    }
  })

  useEffect(()=>{
    if (role === SCHOOL_ADMIN && location.pathname !== "/facilitator-workshop" ) {
      system_messages_from_katon();
    }
  },[location.pathname])

  return (
    <div className='adminSidebarMainContainer'>
      <div className='adminSidebarMainBox'>
        <div className="adminSidebarProfile" style={{ flex: role === SCHOOL_ADMIN ? '' : 'unset' }}>
          <div className="adminSidebarProfileImage">
            {(profileImage) && (<img
              className="adminSidebarProfileTag"
              alt="ProfileImage"
              src={profileImage}
            />)}
          </div>
          <div className={(role === SCHOOL_ADMIN && location.pathname !== "/facilitator-workshop") ? '' : 'teacherTabContainer'}>
            <Tooltip
              title={`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
              disableHoverListener={!isOverflow}
              placement="top">
              <div
                className="adminSidebarProfileText"
                ref={schoolNameRef}
                onMouseEnter={checkOverflow}
              >
                {`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
              </div>
            </Tooltip>
            <div className={(role === SCHOOL_ADMIN && location.pathname !== "/facilitator-workshop") ? 'hide' : 'teacherTab'}>
              Facilitator
            </div>
          </div>
        </div>
        <div className={`${(role === SCHOOL_ADMIN && location.pathname !== "/facilitator-workshop") ? "adminSidebarCards" : 'visiblityHide'} `}>
          <Link to={"/admin-school"} className={`adminSidebarSchoolCard ${location.pathname === "/admin-school" ? "adminSidebarSelectedCard" : ""}`}>
            <label htmlFor="customize-school" className="adminSidebarSchoolLabel">Customize</label>
            <span className="adminSidebarSchoolText">School</span>
          </Link>
          <Link to={"/admin-calendar"} className={`adminSidebarCalendarCard ${location.pathname === "/admin-calendar" ? "adminSidebarSelectedCard" : ""}`}>
            <label htmlFor="edit-calendar" className="adminSidebarCalendarLabel">Edit</label>
            <span className="adminSidebarCalendarText">Calendar</span>
          </Link>
        </div>
        <div className="adminSidebarMenuContainer" style={{ paddingBottom: role === SCHOOL_ADMIN ? '' : '30px', flex: role === SCHOOL_ADMIN ? '' : 'unset' }}>
          <div className={`${role === SCHOOL_ADMIN ? "adminSidebarMenuSet" : 'hide'} `}>
            {/* First Set */}
            {getMenuItemsBySet("setOne").map((item: any) => (
              <Link className={`menu${item?.id} ${location.pathname === item?.link ? "selectedMenu" : ""}`} key={item.id} to={item.link}>
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>
               {(item.id === 'System-messages'  && systemMessageCount > 0) && <div className='notificationBadge'>{systemMessageCount}</div>}
              </Link>
            ))}
          </div>
          <div className={`${role === SCHOOL_ADMIN ? "adminSidebarMenuSet" : 'hide'} `}>
            {/* Second Set */}
            {getMenuItemsBySet("setTwo").map((item: any) => (
              <Link className={`menu${item?.id} ${`/${location.pathname.split('/')[1]}` === `${item?.link}` ? "selectedMenu" : ""}`} key={item.id} to={item.link}>
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>             
              </Link>
            ))}
          </div>
          <div className="adminSidebarMenuSet">
            {/* Third Set */}
            {getMenuItemsBySet("setThree").map((item: any) => (
              <div onClick={onLogoutClick} className={`menu${item?.id}`} key={item.id}>
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={`Are you sure you want to Log Out?`}
        gifData={logoutGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'221px'}
      />
    </div>
  );
}

export default AdminSidebar;
